/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { NgxLoggerLevel } from 'ngx-logger';
import { Modules } from 'src/app/models/Modules.enum';

import packageInfo from '../../package.json';

export const environment = {
  production: true,
  habitat_backend_url: 'mash.habitatworkspace.com/habitat/api/',
  developer_server_json_url: null,
  audit_backend_url: 'mash.habitatworkspace.com/audit/api/',
  esite_backend_url: 'mash.habitatworkspace.com/esite/api/',
  conteo_backend_url: 'mash.habitatworkspace.com/conteo/api/',
  reservations_backend_url: 'mash.habitatworkspace.com/reservations/api/',
  reservations_events_backend_url: 'mash.habitatworkspace.com/reservations/events/api/',

  general_backend_url: 'mash.habitatworkspace.com/general/api/',
  reservations_frontend_url: '',
  co2_backend_url: null,
  backend_protocol: 'https://',
  websocket_protocol: 'wss://',
  web_protocol: 'https://',
  modules: [Modules.esite, Modules.reservations],
  nttdata: false,
  collectAuditData: true,
  /**
   * Set to true to allow Admin users create buildings and floors
   */
  can_admin_create_buildings_floors: false,
  /**
   * Set to true to enable periodic keepalive messages to the backend to keep the websocket connection alive.
   */
  websocket_keepalive: true,
  /**
   * If websocket keepalive messages are enabled, this is the interval in milliseconds between them.
   */
  websocket_keepalive_interval: 40000,
  /**
   * Authentication parameters
   */
  ADClientID: '8ac303de-5894-4b57-b10c-c77b0b2442bb',
  redirectionURI: 'mash.habitatworkspace.com/habitat/',
  logoutRedirectionURI: '',
  issuer: 'https://login.microsoftonline.com/f5fd9e16-114f-4820-8de1-6312daf9aebb/v2.0',
  loginUrl: 'https://login.microsoftonline.com/f5fd9e16-114f-4820-8de1-6312daf9aebb/oauth2/v2.0/authorize/',
  logoutUrl: 'https://login.microsoftonline.com/f5fd9e16-114f-4820-8de1-6312daf9aebb/oauth2/v2.0/logout',
  responseType: 'id_token token',
  userInfoEndpoint: 'https://graph.microsoft.com/v1.0/me?$select=employeeId',
  scope: 'openid email profile 8ac303de-5894-4b57-b10c-c77b0b2442bb/.default',

  /**
   * SSO identifier
   */
  sso_identifier: 'Employee ID',
  /**
   * Set to `true` in case custom openID Connect claims (email, ssoId, fullName) are returned on id_token. Set to `false` in case they are returned on access_token.
   */
  idTokenClaims: true,
  sendIdToken: false,
  strictDiscoveryDocumentValidation: false, // Enable strict validation of `discoveryDocument`.

  /**
   * Application version
   */
  version: packageInfo.version,

  /**
   * Logs
   */
  apiUrl: 'api/v1/logs',
  logLevel: NgxLoggerLevel.OFF,
  serverLogLevel: NgxLoggerLevel.OFF,
  disableConsoleLogging: true,
};
